<template>
  <div class="conferme" v-loading="loading">

    <transition name="fade">
      <ricerca v-show="showRicercaPanel" @closeRicerca="closeSearch" @ricerca="ricerca" @stopLoading="(loading = false)" @changeCountry="changeCountry"></ricerca>
    </transition>

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="col-2 no-padding icon-search">
        <el-tooltip class="item" effect="dark" :content="$t('conferme.ricerca')" placement="top-start">
          <el-button @click="openSearch">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-button>
        </el-tooltip>
      </div>
      <div class="label-left col-20 no-padding">
        {{ $t('conferme.conferme').toUpperCase() + ((form.stab.descStab !== '') ? (' - ' + form.stab.descStab) : '') }}
      </div>
    </div>

    <el-table :data="conferme" @row-click="clickRowConferma" class="custom-table">
      <el-table-column
        align="center"
        width="40">
        <template slot-scope="scope">
          <div class="name-wrapper orologio">
            <el-tooltip class="item" effect="dark" :content="$t('conferme.consegnaFT')" placement="top-start">
              <icon name="riv-bell" v-if="( scope.row.flgConfFT === '1' )" scale="0.9"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="numConf" align="center" header-align="center" class-name="sfondino"
        :label="$t('conferme.conferma')"
        min-width="105">
      </el-table-column>

      <el-table-column
        prop="dataConsegna" align="center" header-align="center"
        :label="$t('conferme.dataConsegna')"
        min-width="175">
        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.datConsDa + ' - ' + scope.row.datConsA }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="qtaOrd" align="right" header-align="right"
        :label="$t('conferme.ordinato')"
        min-width="90">
      </el-table-column>

      <el-table-column
        align="right" header-align="right"
        :label="$t('conferme.ricevuto')"
        min-width="90">
        <template slot-scope="scope">
          <div class="name-wrapper">
            {{scope.row.qtaRic | formatString}}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="right" header-align="right"
        :label="$t('conferme.qtaViaggiante')"
        min-width="120">
        <template slot-scope="scope">
          <div class="name-wrapper">
            {{scope.row.qtaVia | formatString}}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="right" header-align="right"
        :label="$t('conferme.qtaMancante')"
        min-width="120">
        <template slot-scope="scope">
          <div class="name-wrapper">
            {{scope.row.qtaMan | formatString}}
          </div>
        </template>
      </el-table-column>

      <el-table-column align="right"
                       width="55">
        <template slot-scope="scope">
          <div class="list-wrapper actions">
            <el-tooltip class="item" effect="dark" :content="$t('conferme.listaProdotti')" placement="top-start">
              <icon name="riv-menuMng" @click.native.stop="getListProdotti(scope.row.numConf)" scale="1.2"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog class="tabella-prodotti" :title="$t('conferme.listaProdotti').toUpperCase()"
               :visible.sync="showProdotti" :append-to-body="true"
               custom-class="custom-dialog offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-1 col-22">

      <el-table :data="prodotti" class="custom-table">
        <el-table-column
          :label="$t('conferme.codice')"
          align="center" header-align="center" prop="codProd"
          min-width="65">
        </el-table-column>

        <el-table-column
          prop="desProd"
          :label="$t('conferme.descrizione')"
          min-width="160">
        </el-table-column>

        <el-table-column
          prop="codEurofer" align="center" header-align="center"
          :label="$t('conferme.eurofer')"
          min-width="65">
        </el-table-column>

        <el-table-column
          prop="codCECA" align="center" header-align="center"
          :label="$t('conferme.ceca')"
          min-width="65">
        </el-table-column>
      </el-table>

    </el-dialog>

    <el-dialog :title="$t('conferme.tipoDiTrasporto').toUpperCase()"
               :visible.sync="showTipoTrasporto" :append-to-body="true"
               custom-class="custom-dialog offset-xl-8 col-xl-8 offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-1 col-22">

      <el-radio-group v-model="tipoTrasporto" @change="selectModoTrasp">
        <el-radio label="3">{{ $t('conferme.camion') }}</el-radio>
        <br>
        <el-radio label="2">{{ $t('conferme.vagone') }}</el-radio>
      </el-radio-group>

    </el-dialog>

  </div>
</template>

<script>
  import {bus} from '../../Bus'
  import Ricerca from './Ricerca.vue'

  export default {
    name: 'Conferme',
    components: {Ricerca},
    filters: {
      formatString: function (string) {
        if (string === '') {
          return ' '
        }
        return string
      }
    },
    i18n: {
      messages: {
        it_IT: {
          conferme: {
            conferme: 'Conferme',
            conferma: 'Conferma',
            dataConsegna: 'Data consegna',
            ordinato: 'Ordinato',
            ricevuto: 'Ricevuto',
            qtaViaggiante: 'Qta viaggiante',
            qtaMancante: 'Qta mancante',
            ricerca: 'Ricerca',
            consegnaFT: 'Consegna fuori termine',
            listaProdotti: 'Lista prodotti',
            codice: 'Codice',
            descrizione: 'Descrizione',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            tipoDiTrasporto: 'Selezionare il tipo di trasporto',
            camion: 'Camion',
            vagone: 'Vagone',
            erroreConferma: 'Conferma con spedizione via chiatta o nave marittima. Non è possibile gestire buoni di scarico.'
          }
        },
        fr_FR: {
          conferme: {
            conferme: 'Confirmations',
            conferma: 'Comm.',
            dataConsegna: 'Date de livraison',
            ordinato: 'Qté Cdée',
            ricevuto: 'Qté Reçue',
            qtaViaggiante: 'Qté en cours',
            qtaMancante: 'Qté manquante',
            ricerca: 'Recherche',
            consegnaFT: 'Livraison hors délai',
            listaProdotti: 'Liste de produits',
            codice: 'Code',
            descrizione: 'Description',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            tipoDiTrasporto: 'Sélectionnez le type de transport',
            camion: 'Camions',
            vagone: 'Wagon',
            erroreConferma: 'Commande avec expédition par péniche ou navire maritime. Les bons de déchargement ne peuvent pas être traités.'
          }
        },
        es_ES: {
          conferme: {
            conferme: 'Confirmaciones',
            conferma: 'Pedi.',
            dataConsegna: 'Día de entrega',
            ordinato: 'Cant. pedida',
            ricevuto: 'Cant. solicitada',
            qtaViaggiante: 'Cant. entregada',
            qtaMancante: 'Cant. restante',
            ricerca: 'Búsqueda',
            consegnaFT: 'Entrega fuera de plazo',
            listaProdotti: 'Lista de productos',
            codice: 'Código',
            descrizione: 'Descripción',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            tipoDiTrasporto: 'Seleccione el tipo de transporte',
            camion: 'Camiones',
            vagone: 'Vagón',
            erroreConferma: 'Pedido con envío por barcaza o buque marítimo. Los vales de descarga no pueden ser manejados.'
          }
        },
        de_DE: {
          conferme: {
            conferme: 'Verträge',
            conferma: 'Verträge',
            dataConsegna: 'Lieferzeitraum',
            ordinato: 'Bestellt',
            ricevuto: 'Erhalten',
            qtaViaggiante: 'Unterwegsmenge',
            qtaMancante: 'Fehlmenge',
            ricerca: 'Suche',
            consegnaFT: 'Außergewöhnliche Lieferung',
            listaProdotti: 'Produktliste',
            codice: 'Code',
            descrizione: 'Beschreibung',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            tipoDiTrasporto: 'Wählen Sie die Transportart',
            camion: 'LKW',
            vagone: 'Waggon',
            erroreConferma: 'Bestellung mit Versand per Binnenschiff oder Seeschiff. Entladenscheine können nicht bearbeitet werden.'
          }
        },
        en_GB: {
          conferme: {
            conferme: 'Confirmations',
            conferma: 'Conf.',
            dataConsegna: 'Delivery date',
            ordinato: 'Ordered',
            ricevuto: 'Received',
            qtaViaggiante: 'Traveling qty',
            qtaMancante: 'Missing qty',
            ricerca: 'Search',
            consegnaFT: 'Out-of-term delivery',
            listaProdotti: 'Product list',
            codice: 'Code',
            descrizione: 'Description',
            eurofer: 'Eurofer',
            ceca: 'Ceca',
            tipoDiTrasporto: 'Select the type of transport',
            camion: 'Truck',
            vagone: 'Wagon',
            erroreConferma: 'Order with shipment by barge or sea vessel. Unloading pass cannot be handled.'
          }
        }
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        conferme: [],
        form: {
          stab: {
            descStab: ''
          }
        },
        showProdotti: false,
        prodotti: [],
        loading: false,
        showRicercaPanel: false,
        showTipoTrasporto: false,
        tipoTrasporto: '',
        conferma: {},
        codForn: ''
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'conferme', [])
      })
      bus.$on('TRAACQ_ChangeCountryFromDsh', () => {
        this.$set(this, 'conferme', [])
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      resetDati: function () {
        this.$set(this, 'conferme', [])
        let form = {
          stab: {
            descStab: ''
          }
        }
        this.$set(this, 'form', form)
        this.$set(this, 'prodotti', [])
        this.$set(this, 'showProdotti', false)
        this.$set(this, 'showRicercaPanel', false)
        this.$set(this, 'showTipoTrasporto', false)
        this.$set(this, 'tipoTrasporto', '')
        this.$set(this, 'conferma', {})
      },
      init: function () {
        if (sessionStorage.hasOwnProperty('WGR_form')) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('WGR_form')))
          this.$set(this, 'codForn', this.form.fornitore.tipForn + this.form.fornitore.codForn)
          this.getConferme()
        }
      },
      changeCountry: function () {
        this.$set(this, 'conferme', [])
      },
      openSearch: function () {
        this.showRicercaPanel = true
        this.$emit('hideScroll')
      },
      closeSearch: function () {
        this.showRicercaPanel = false
        this.$emit('showScroll')
      },
      ricerca: function (form) {
        this.$set(this, 'loading', true)
        this.$set(this, 'form', JSON.parse(form))
        this.$set(this, 'codForn', this.form.fornitore.tipForn + this.form.fornitore.codForn)
        if (!this._inactive) {
          this.getConferme()
        }
      },
      selectModoTrasp: function (newModoTrasp) {
        this.$set(this, 'showTipoTrasporto', false)
        let conf = JSON.parse(JSON.stringify(this.conferma))
        conf.modoTrasp = newModoTrasp
        this.selectConferma(conf)
      },
      clickRowConferma: function (row, event, column) {
        if (row.modoTrasp === 'M') {
          this.$set(this, 'conferma', row)
          this.$set(this, 'showTipoTrasporto', true)
        } else {
          this.selectConferma(row)
        }
      },
      selectConferma: function (conferma) {
        if (conferma.modoTrasp === 'B') {
          this.$message({
            showClose: true,
            message: this.$t('conferme.erroreConferma'),
            type: 'error',
            duration: process.env.duration
          })
        } else {
          sessionStorage.setItem('WGR_conf', JSON.stringify(conferma))
          if (sessionStorage.hasOwnProperty('WGR_form')) {
            let form = JSON.parse(sessionStorage.getItem('WGR_form'))
            form.ifTSL = {desc: this.$t('ricerca.tutti').toUpperCase(), value: '*'}
            sessionStorage.setItem('WGR_form', JSON.stringify(form))
          }
          this.$router.push({ name: 'GestioneRottameElencoBuoni' })
        }
      },
      getConferme: function () {
        this.loading = true
        bus.$emit('Header_ChangeAdmin', this.form.country, 'TRAACQ')
        if (localStorage.getItem('TRAACQ_country') !== this.form.country) {
          localStorage.setItem('TRAACQ_country', parseInt(this.form.country))
          bus.$emit('TRAACQ_ChangeCountryFromApp')
        }
        this.$http.get('buonidiscarico/conferme', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codStab: this.form.stab.codStab,
            codSoc: this.form.stab.codSoc,
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'conferme', response.body.data)
            } else {
              this.$set(this, 'conferme', [])
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.loading = false
          }, response => {
            this.$set(this, 'conferme', [])
            this.$message({
              showClose: true,
              message: response,
              type: 'error',
              duration: process.env.duration
            })
          })
      },
      getListProdotti: function (numConf) {
        this.$http.get('buonidiscarico/prodotti', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codStab: this.form.stab.codStab,
            codSoc: this.form.stab.codSoc,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn,
            numConf: numConf
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.showProdotti = true
              this.$set(this, 'prodotti', response.body.data)
            } else {
              this.$set(this, 'prodotti', [])
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          }, response => {
            this.$set(this, 'prodotti', [])
            this.$message({
              showClose: true,
              message: response,
              type: 'error',
              duration: process.env.duration
            })
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .tabella-prodotti {
    .el-dialog__header {
      border-bottom: 0! important;
    }
    .el-table {
      margin-top: 10px;
    }
  }

  .conferme {
    .header-tab {
      height: 65px;
      text-align: center;
      .label-left {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0;
          margin: 12px 0 0 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .el-table {
      margin-top: 10px;
      .el-table__body-wrapper {
        tbody {
          tr:hover>td {
            cursor:pointer;
          }
          tr {
            .cell {
              .orologio {
                color: @oroRiva;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/Conferme.vue